module.exports = __webpack_public_path__ + "42e586df922187ffe00f9d25c5388fcd.png";